import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa548b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-container" }
const _hoisted_2 = { class: "grid-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "List:", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "datasource-name" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "grid-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Visibility:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Color:", -1))
const _hoisted_10 = { class: "color-switch-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Filter name:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Filter category:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Description:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Columns:", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Select all")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Deselect all")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Invert")
const _hoisted_18 = { class: "column-list" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Filters:", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "param-container" }
const _hoisted_22 = { class: "param-title" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 0,
  class: "param-value"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "range-container"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "param-label" }, "min", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "param-label" }, "max ", -1))
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  style: {"margin-top":"8px"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "param-label" }, "Past ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " days", -1))
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 1,
  class: "range-container"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "param-label" }, "start", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "param-label" }, "end ", -1))
const _hoisted_47 = { key: 4 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 5 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Schedule:", -1))
const _hoisted_52 = { class: "schedule-container" }
const _hoisted_53 = { class: "schedule-check-box-container" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" UI view ")
const _hoisted_55 = { class: "schedule-check-box" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" email report ")
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "scheduling-label" }, "On:", -1))
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "scheduling-label" }, "On:", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"4px"} }, "of every month", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "scheduling-label" }, "At:", -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" GMT ")
const _hoisted_65 = { class: "recipients" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "scheduling-label" }, "To:", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_69 = {
  id: "gridContainer",
  ref: "grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_k_drop_down_list = _resolveComponent("k-drop-down-list")!
  const _component_k_radio_group = _resolveComponent("k-radio-group")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_text_area = _resolveComponent("k-text-area")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_k_checkbox = _resolveComponent("k-checkbox")!
  const _component_k_button_group = _resolveComponent("k-button-group")!
  const _component_k_numeric_text_box = _resolveComponent("k-numeric-text-box")!
  const _component_k_date_time_picker = _resolveComponent("k-date-time-picker")!
  const _component_kendo_daterangepicker = _resolveComponent("kendo-daterangepicker")!
  const _component_k_multi_select = _resolveComponent("k-multi-select")!
  const _component_k_combo_box = _resolveComponent("k-combo-box")!
  const _component_k_time_picker = _resolveComponent("k-time-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        (_ctx.pageMode == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.listTitle), 1)
            ]))
          : (_ctx.pageMode == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_k_drop_down_list, {
                  "data-items": _ctx.dataSources,
                  "text-field": 'Name',
                  "data-item-key": 'Id',
                  style: { width: '390px' },
                  onChange: _ctx.setDataView
                }, null, 8, ["data-items", "onChange"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", null, [
        _createVNode(_component_k_radio_group, {
          modelValue: _ctx.GridFilter.Kind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.GridFilter.Kind) = $event)),
          "data-items": _ctx.visibilityOptions,
          layout: 'horizontal'
        }, null, 8, ["modelValue", "data-items"])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_k_radio_group, {
          modelValue: _ctx.GridFilter.Color,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.GridFilter.Color) = $event)),
          "data-items": _ctx.colorOptions,
          layout: 'horizontal'
        }, null, 8, ["modelValue", "data-items"])
      ]),
      _hoisted_11,
      _createElementVNode("div", null, [
        _createVNode(_component_k_input, {
          modelValue: _ctx.GridFilter.Name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.GridFilter.Name) = $event)),
          required: true
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_12,
      _createElementVNode("div", null, [
        _createVNode(_component_k_drop_down_list, {
          modelValue: _ctx.GridFilter.FormDataGridFilterCategory,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.GridFilter.FormDataGridFilterCategory) = $event)),
          "data-items": _ctx.GridFilterCategories,
          "data-item-key": 'Id',
          "text-field": 'Name',
          style: {"width":"390px"},
          placeholder: "select one item"
        }, null, 8, ["modelValue", "data-items"])
      ]),
      _hoisted_13,
      _createElementVNode("div", null, [
        _createVNode(_component_k_text_area, {
          modelValue: _ctx.GridFilter.Description,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.GridFilter.Description) = $event)),
          size: 'large',
          resizable: true,
          rows: 5
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_14,
      _createElementVNode("div", null, [
        _createVNode(_component_k_button, {
          icon: 'k-icon k-i-checkbox-checked',
          onClick: _withModifiers(_ctx.selectAll, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_k_button, {
          icon: 'k-icon k-i-checkbox',
          onClick: _withModifiers(_ctx.deselectAll, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_k_button, {
          icon: 'k-icon k-i-invert-colors',
          onClick: _withModifiers(_ctx.invert, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridFields, (field, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "row-container"
            }, [
              _createVNode(_component_k_checkbox, {
                modelValue: field.selected,
                "onUpdate:modelValue": ($event: any) => ((field.selected) = $event),
                label: field.title,
                value: field.fieldPath
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value"]),
              _createVNode(_component_k_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_k_button, {
                    class: "sort-button",
                    toggable: 'true',
                    icon: field.icon,
                    onClick: _withModifiers(($event: any) => (_ctx.setState(idx)), ["prevent"])
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ]),
      _hoisted_19,
      _createElementVNode("div", null, [
        (!_ctx.parameters || _ctx.parameters.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No filters available "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (param, idx) => {
          return (_openBlock(), _createElementBlock("div", { key: idx }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", {
                  for: param.Name
                }, _toDisplayString(param.Label), 9, _hoisted_23),
                _createElementVNode("span", {
                  title: param.Description,
                  class: "k-icon k-i-question help"
                }, null, 8, _hoisted_24)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_k_drop_down_list, {
                  modelValue: _ctx.getParamValue(param).OperatorSelected,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).OperatorSelected) = $event),
                  "data-items": _ctx.getParamDataItems(param),
                  "text-field": 'text',
                  "data-item-key": 'id',
                  style: { width: '390px' },
                  value: _ctx.getParamValue(param).OperatorSelected,
                  onChange: ($event: any) => (_ctx.setParamValueType($event, param))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "data-items", "value", "onChange"]),
                (_ctx.getParamValue(param)?.ValueType != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (param.ParamType == 0 || param.ParamType == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_k_input, {
                              modelValue: _ctx.getParamValue(param).ValueObj[0],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[0]) = $event),
                              placeholder: "insert text here...",
                              required: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]))
                        : (param.ParamType == 9)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_k_checkbox, {
                                modelValue: _ctx.getParamValue(param).ValueBoolean,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueBoolean) = $event),
                                required: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (_ctx.getParamValue(param).ValueBoolean == true)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, " checked"))
                                : _createCommentVNode("", true),
                              (_ctx.getParamValue(param).ValueBoolean == false)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "unchecked"))
                                : _createCommentVNode("", true)
                            ]))
                          : (param.ParamType == 2 || param.ParamType == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_ctx.getParamValue(param)?.ValueType == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createVNode(_component_k_numeric_text_box, {
                                        modelValue: _ctx.getParamValue(param).ValueObj[0],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[0]) = $event),
                                        format: _ctx.getParamValue(param)?.Format,
                                        placeholder: "i.e.: 1234",
                                        required: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                                    ]))
                                  : (_ctx.getParamValue(param)?.ValueType == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("div", null, [
                                          _hoisted_33,
                                          _createVNode(_component_k_numeric_text_box, {
                                            modelValue: _ctx.getParamValue(param).ValueObj[0],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[0]) = $event),
                                            format: _ctx.getParamValue(param)?.Format,
                                            placeholder: "i.e.: 1234",
                                            required: true
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _hoisted_34,
                                          _createVNode(_component_k_numeric_text_box, {
                                            modelValue: _ctx.getParamValue(param).ValueObj[1],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[1]) = $event),
                                            format: _ctx.getParamValue(param)?.Format,
                                            placeholder: "i.e.: 1234",
                                            required: true
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : (param.ParamType == 4 || param.ParamType == 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  (_ctx.getParamValue(param)?.ValueType == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createVNode(_component_k_drop_down_list, {
                                          modelValue: 
                        _ctx.getParamValue(param).DateTimeSingleOptionSelected
                      ,
                                          "onUpdate:modelValue": ($event: any) => ((
                        _ctx.getParamValue(param).DateTimeSingleOptionSelected
                      ) = $event),
                                          "data-items": _ctx.dateTimeSingleOptions,
                                          "data-item-key": 'id',
                                          "text-field": 'text',
                                          style: {"width":"390px"},
                                          placeholder: "select one item",
                                          required: true
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "data-items"]),
                                        (_ctx.getParamValue(param)?.DateTimeSingleOptionSelected)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              (
                          _ctx.getParamValue(param)?.DateTimeSingleOptionSelected
                            ?.id == 7
                        )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                    _hoisted_39,
                                                    _createVNode(_component_k_numeric_text_box, {
                                                      modelValue: _ctx.getParamValue(param).ValueInt,
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueInt) = $event),
                                                      format: 'n0',
                                                      placeholder: "i.e.: 1234",
                                                      required: true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                    _hoisted_40
                                                  ]))
                                                : (
                          _ctx.getParamValue(param)?.DateTimeSingleOptionSelected
                            ?.id == 8
                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                      _createVNode(_component_k_date_time_picker, {
                                                        modelValue: _ctx.getParamValue(param).ValueObj[0],
                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[0]) = $event),
                                                        style: { width: '390px', 'margin-top': '8px' },
                                                        required: true
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.getParamValue(param)?.ValueType == 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                          _createVNode(_component_k_drop_down_list, {
                                            modelValue: _ctx.getParamValue(param).DateTimeRangeOptionSelected,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).DateTimeRangeOptionSelected) = $event),
                                            "data-items": _ctx.dateTimeRangeOptions,
                                            "data-item-key": 'id',
                                            "text-field": 'text',
                                            required: true,
                                            onChange: ($event: any) => (_ctx.onRangeOptionsChange($event, param))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "data-items", "onChange"]),
                                          (
                        _ctx.getParamValue(param)?.DateTimeRangeOptionSelected.id ==
                        0
                      )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                _createVNode(_component_kendo_daterangepicker, {
                                                  modelValue: _ctx.getParamValue(param).ValueObj,
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj) = $event),
                                                  format: 'MM/dd/yyyy'
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : (
                        _ctx.getParamValue(param)?.DateTimeRangeOptionSelected.id ==
                        1
                      )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                  _createElementVNode("div", null, [
                                                    _hoisted_45,
                                                    _createVNode(_component_k_numeric_text_box, {
                                                      modelValue: _ctx.getParamValue(param).ValueInt[0],
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueInt[0]) = $event),
                                                      format: _ctx.getParamValue(param)?.Format,
                                                      placeholder: "i.e.: 1234",
                                                      required: true,
                                                      max: 0
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                                                  ]),
                                                  _createElementVNode("div", null, [
                                                    _hoisted_46,
                                                    _createVNode(_component_k_numeric_text_box, {
                                                      modelValue: _ctx.getParamValue(param).ValueInt[1],
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueInt[1]) = $event),
                                                      format: _ctx.getParamValue(param)?.Format,
                                                      placeholder: "i.e.: 1234",
                                                      required: true,
                                                      max: 0
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : (param.ParamType == 6)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    (_ctx.getParamValue(param)?.ValueType == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                          _createVNode(_component_k_drop_down_list, {
                                            modelValue: _ctx.getParamValue(param).ValueObj[0],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.getParamValue(param).ValueObj[0]) = $event),
                                            "data-items": param.List,
                                            style: {"width":"390px"},
                                            "data-item-key": 'Key',
                                            "text-field": 'Value',
                                            placeholder: "select one item",
                                            required: true
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "data-items"])
                                        ]))
                                      : (_ctx.getParamValue(param)?.ValueType == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _createVNode(_component_k_multi_select, {
                                              "data-items": param.List,
                                              style: {"width":"390px"},
                                              "data-item-key": 'Key',
                                              "text-field": 'Value',
                                              placeholder: "select multiple items",
                                              value: _ctx.getParamValue(param).ValueObj,
                                              onChange: ($event: any) => (_ctx.setMultiValue($event, _ctx.getParamValue(param)))
                                            }, null, 8, ["data-items", "value", "onChange"])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, "No component defined"))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_51,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", null, [
              _createVNode(_component_k_checkbox, {
                modelValue: _ctx.schedule.IsUiView,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schedule.IsUiView) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_54
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createVNode(_component_k_checkbox, {
                modelValue: _ctx.schedule.IsEmailReport,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.schedule.IsEmailReport) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_56
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_k_combo_box, {
              modelValue: _ctx.schedule,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.schedule) = $event)),
              "data-item-key": 'id',
              "data-items": _ctx.schedulingOptions,
              style: {"width":"390px"},
              "text-field": 'text',
              "clear-button": false
            }, null, 8, ["modelValue", "data-items"])
          ]),
          (_ctx.schedule.id != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                (_ctx.schedule.id == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode(_component_k_combo_box, {
                        modelValue: _ctx.schedule.WeekDay,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.schedule.WeekDay) = $event)),
                        "data-item-key": 'id',
                        "data-items": _ctx.weekdayOptions,
                        style: {"width":"160px"},
                        "text-field": 'text',
                        "clear-button": false,
                        value: _ctx.schedule.WeekDay
                      }, null, 8, ["modelValue", "data-items", "value"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.schedule.id == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_k_combo_box, {
                        modelValue: _ctx.schedule.MonthDay,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.schedule.MonthDay) = $event)),
                        "data-items": _ctx.dayOfMonthOptions,
                        "clear-button": false,
                        value: _ctx.schedule.MonthDay,
                        "default-value": 1
                      }, null, 8, ["modelValue", "data-items", "value"]),
                      _hoisted_62
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _hoisted_63,
                  _createVNode(_component_k_time_picker, {
                    modelValue: _ctx.schedule.Time,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.schedule.Time) = $event)),
                    format: 'HH:mm'
                  }, null, 8, ["modelValue"]),
                  _hoisted_64
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_k_multi_select, {
                    modelValue: _ctx.schedule.Recipients,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.schedule.Recipients) = $event)),
                    class: "recipients-selection",
                    "data-items": _ctx.schedule.Recipients,
                    value: _ctx.schedule.RecipientsValue,
                    "allow-custom": true,
                    placeholder: "recipient email i.e.: software@theprintspace.co.uk",
                    onChange: _ctx.validateRecipient
                  }, null, 8, ["modelValue", "data-items", "value", "onChange"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_67,
      _createElementVNode("div", null, [
        _createVNode(_component_k_button, {
          "icon-class": 'k-icon k-i-save',
          class: "save-button",
          onClick: _withModifiers(_ctx.saveGridFilter, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_68
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_69, null, 512)
    ], 512), [
      [_vShow, _ctx.pageMode == 1 || (_ctx.pageMode == 0 && _ctx.GridFilter.DataView)]
    ])
  ]))
}